// Libs
import { useDispatch } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';

// Actions
import {
  DeleteKit,
  DeleteKitInDetailsMode,
  DeleteAllKits,
} from '../../../actions/kits';
import { OpenModal } from '../../../actions/modal';
import { Open2Modal } from '../../../actions/modal2';

// Components
import ConfirmCard from '../../../components/Cards/ConfirmCard';

// Hooks
import useUI from '../../../hooks/useUI';

// Constants
import {
  CONFIRM_MODAL_HEIGHT_DESKTOP,
  CONFIRM_MODAL_HEIGHT_MOBILE,
  CONFIRM_MODAL_WIDTH_DESKTOP,
  CONFIRM_MODAL_WIDTH_MOBILE,
  CONFIRM_MODAL_WIDTH_TABLET,
} from '../../../constants/modals';

const useDeleteKits = () => {
  const dispatch = useDispatch();
  const { isTabletMode, isMobileMode } = useUI();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const confirmDeleteKit = (kitId) => dispatch(DeleteKit(kitId));
  const confirmDeleteKitInDetailsMode = (kitId) =>
    dispatch(DeleteKitInDetailsMode(kitId));

  const confirmDeleteAllKits = () => dispatch(DeleteAllKits());

  const showDeleteConfirmation = ({ message, onConfirm }) => {
    let width;
    if (isMobileMode) {
      width = CONFIRM_MODAL_WIDTH_MOBILE;
    } else if (isTabletMode) {
      width = CONFIRM_MODAL_WIDTH_TABLET;
    } else {
      width = CONFIRM_MODAL_WIDTH_DESKTOP;
    }

    dispatch(
      OpenModal({
        Component: ConfirmCard,
        props: {
          message,
          onConfirm,
          isAcceptBtnMain: false,
          paddingContent: {
            xl: '40px 40px 30px',
            lg: '40px 40px 30px',
            md: '30px 16px 20px',
          },
        },
        styles: {
          width,
          minHeight: isMobileMode
            ? CONFIRM_MODAL_HEIGHT_MOBILE
            : CONFIRM_MODAL_HEIGHT_DESKTOP,
        },
      }),
    );
  };

  const showDeleteConfirmation2 = ({ message, onConfirm }) => {
    let width;
    if (isMobileMode) {
      width = CONFIRM_MODAL_WIDTH_MOBILE;
    } else if (isTabletMode) {
      width = CONFIRM_MODAL_WIDTH_TABLET;
    } else {
      width = CONFIRM_MODAL_WIDTH_DESKTOP;
    }

    dispatch(
      Open2Modal({
        Component: ConfirmCard,
        props: {
          modal2Mode: true,
          message,
          onConfirm,
          isAcceptBtnMain: false,
          paddingContent: {
            xl: '40px 40px 30px',
            lg: '40px 40px 30px',
            md: '30px 16px 20px',
          },
        },
        styles: {
          width,
          height: isMobileMode
            ? CONFIRM_MODAL_HEIGHT_MOBILE
            : CONFIRM_MODAL_HEIGHT_DESKTOP,
          minHeight: CONFIRM_MODAL_HEIGHT_MOBILE,
        },
      }),
    );
  };

  const onDeleteMyKit = (kitId) =>
    showDeleteConfirmation({
      message: 'Deleting Will Remove This Kit From Your Kits.',
      onConfirm: () => {
        confirmDeleteKit(kitId);
        if (pathname !== '/kits') {
          navigate('/kits');
        }
      },
    });

  const onDeleteMyKitInDetailsMode = (kitId) =>
    showDeleteConfirmation2({
      message: 'Deleting Will Remove This Kit From Your Kits.',
      onConfirm: () => {
        confirmDeleteKitInDetailsMode(kitId);
        if (pathname !== '/kits') {
          navigate('/kits');
        }
      },
    });

  const onDeleteAllKits = () =>
    showDeleteConfirmation({
      message: 'Deleting Will Remove All Your Kits.',
      onConfirm: confirmDeleteAllKits,
    });

  return { onDeleteMyKit, onDeleteMyKitInDetailsMode, onDeleteAllKits };
};

export default useDeleteKits;
